<script lang="ts">
    import { sortableForceFallbackForFirefox } from "../genericHandlers";
    import { screenLayout, ScreenLayouts } from "../store";
    import { Tutorial } from "./Tutorial";

    function startTutorial() {
        new Tutorial().start();
    }
</script>

<div
    id="welcome-box"
    class="min-height-15rem margin-bottom-1rem padding-1rem center-contents-vh border-solid-2px border-blue border-radius-pico-border-radius background-color-blue-10a"
>
    <h2>Welcome to Bardic Tools!</h2>

    {#if $screenLayout === ScreenLayouts.Mobile  }
        <div>
            <p>
                Bardic Tools is better experienced on Desktop. While you get to
                your computer, watch this short walkthrough to get you from 0 to
                Epic music!
            </p>
        </div>
        <div>
            <iframe
                width="100%"
                style="aspect-ratio: 16 / 9;"
                src="https://www.youtube.com/embed/RV0xeYA_UXc?si=Y2xk31TIfJNVcpfW"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    {:else if sortableForceFallbackForFirefox()}
        <div>
            <p>
                The Bardic Tools tutorial is better experienced on Google Chrome. 
                However, here's a short walkthrough to get you from 0 to
                Epic music!
            </p>
        </div>
        <div>
            <iframe
                width="100%"
                style="aspect-ratio: 16 / 9;"
                src="https://www.youtube.com/embed/RV0xeYA_UXc?si=Y2xk31TIfJNVcpfW"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    {:else}
        <div>
            <p>
                Explore on your own, or let us guide you through this <span
                    ><strong>short tutorial</strong></span
                >:
            </p>
        </div>
        <button class="contrast" on:click={startTutorial}
            >Tutorial: Build An Epic Scene in 5 Minutes</button
        >
    {/if}
</div>
